import { Injectable, computed, inject } from '@angular/core';
import { PermissionService } from './permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionPolicy {
  private readonly perms = inject(PermissionService);

  // Admin
  readonly canUpdateApplicationStatus = this.perms.hasAuthPermissions(
    'update_application_status'
  );
  readonly canViewOperationsApplicationList = this.perms.hasAuthPermissions(
    'view_operations_application_list'
  );
  readonly canViewSchoolApplicationList = this.perms.hasAuthPermissions(
    'view_school_application_list'
  );

  // applicant
  readonly canSubmitApplication =
    this.perms.hasAuthPermissions('submit_application');

  // full Admin capabilities
  readonly isAdmin = computed(
    () => this.isOperationsAdmin() || this.canViewSchoolApplicationList()
  );

  //school admin
  readonly isSchoolAdmin = computed(
    () =>
      this.canViewSchoolApplicationList() &&
      !this.isOperationsAdmin()
  );

  // full Operations capabilities
  readonly isOperationsAdmin = computed(
    () =>
      this.canUpdateApplicationStatus() &&
      this.canViewOperationsApplicationList()
  );

  // full Applicant edit capabilities
  readonly canEditAnyApplicationSection = computed(() =>
    this.canSubmitApplication()
  );
}
